import styled from "styled-components";

export const PageHeaderSkeletonTextStack = styled.div.attrs({
  className: "space-y-1.5",
})``;

export const PageHeaderSkeletonSectionBody = styled.div.attrs({
  className: "mb-6 w-full",
})``;

export const LoadingSectionBody = styled.div.attrs({
  className: "flex flex-col gap-4 md:flex-row md:items-end md:justify-between",
})``;

export const LoadingContentStack = styled.div.attrs({ className: "space-y-3" })``;

export const LoadingSection = styled.div.attrs({ className: "flex flex-wrap gap-3" })``;

export const LoadingContentStackSecondary = styled.div.attrs({
  className: "brand-panel space-y-5",
})``;

export const LoadingSectionBodySecondary = styled.div.attrs({
  className: "flex flex-col gap-4 md:flex-row md:items-start md:justify-between",
})``;

export const LoadingPanelCard = styled.div.attrs({
  className:
    "relative overflow-hidden rounded-[24px] border border-[var(--brand-border)] bg-[var(--brand-bg)]/55 p-5",
})``;

export const LoadingSectionSecondary = styled.div.attrs({
  className:
    "absolute inset-0 bg-[rgba(30,35,42,0.96)]",
})``;

export const LoadingMediaSurface = styled.div.attrs({
  className: "brand-panel-muted relative overflow-hidden",
})``;

export const LoadingSectionTertiary = styled.div.attrs({
  className: "absolute inset-x-0 top-0 h-1 bg-[var(--brand-highlight)]/30",
})``;

export const LoadingGridLayout = styled.div.attrs({
  className: "mb-8 grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const LoadingContentStackTertiary = styled.div.attrs({ className: "space-y-3 md:hidden" })``;

export const LoadingSectionQuaternary = styled.div.attrs({ className: "brand-panel-muted" })``;

export const LoadingGridLayoutSecondary = styled.div.attrs({
  className: "grid grid-cols-[92px_minmax(0,1fr)] gap-3",
})``;

export const LoadingInfoRow = styled.div.attrs({ className: "flex items-center gap-3" })``;

export const LoadingContentStackQuaternary = styled.div.attrs({ className: "flex-1 space-y-2" })``;

export const LoadingSectionQuinary = styled.div.attrs({
  className: "flex gap-2 border-t border-[var(--brand-border)] pt-3",
})``;

export const LoadingPanelCardSecondary = styled.div.attrs({
  className:
    "hidden overflow-hidden rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] md:block",
})``;

export const LoadingScrollArea = styled.div.attrs({ className: "overflow-x-auto" })``;

export const LoadingDataTable = styled.table.attrs({ className: "brand-table" })``;

export const LoadingHeaderCell = styled.th.attrs({ className: "w-[140px]" })``;

export const LoadingContentStackQuinary = styled.div.attrs({
  className: "min-w-[120px] flex-1 space-y-2",
})``;

export const LoadingSectionSenary = styled.div.attrs({ className: "flex gap-2" })``;

export const LoadingContentStackSenary = styled.div.attrs({ className: "space-y-5" })``;

export const LoadingGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const LoadingSectionSeptenary = styled.div.attrs({
  className: "brand-panel-muted md:col-span-2",
})``;
